function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// Generated by CoffeeScript 1.12.7
(function () {
  var extendedTypeOf;

  extendedTypeOf = function extendedTypeOf(obj) {
    var result;
    result = _typeof(obj);

    if (obj == null) {
      return 'null';
    } else if (result === 'object' && obj.constructor === Array) {
      return 'array';
    } else {
      return result;
    }
  };

  module.exports = {
    extendedTypeOf: extendedTypeOf
  };
}).call(this);